export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100/80 text-primary-700 rounded-full text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>海量漫画 · 免费畅读</span>
            </div>

            <h1 className="text-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-5">
              51漫画网
              <span className="block text-primary-500">在线漫画免费阅读平台</span>
            </h1>

            <p className="text-sm text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51漫画网为您打造流畅的漫画在线阅读体验，汇聚海量热门漫画资源。支持51漫画在线观看和51漫画免费看，
              高清画质更新快，智能下拉式阅读无需翻页等待。无论您偏爱热血、恋爱、奇幻还是悬疑题材，
              这里都有您想要的精彩漫画世界，无需下载即可畅读全本。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs text-foreground-600">日更200+话</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-primary-400"></span>
                <span className="text-xs text-foreground-600">10万+作品收录</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-secondary-400"></span>
                <span className="text-xs text-foreground-600">全本免费无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-bar-chart-fill"></i>
                查看人气榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-lg text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer no-underline border border-background-200/70"
              >
                <i className="ri-book-open-line"></i>
                精选漫画推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20manga%20and%20comic%20reading%20scene%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20abstract%20geometric%20shapes%20with%20comic%20speech%20bubbles%20and%20dynamic%20action%20lines%2C%20modern%20flat%20design%20with%20Japanese%20manga%20influences%2C%20clean%20minimalist%20aesthetic%20with%20soft%20gradients%20and%20warm%20lighting%2C%20editorial%20illustration%20style%20with%20whimsical%20charm&width=960&height=1200&seq=hero-main-visual&orientation=portrait"
                alt="51漫画网 - 在线漫画阅读平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}